








// // //dont delete this part
// // //dont delete this part
// // //dont delete this part
// // //dont delete this part


// // import React, { useState, useEffect } from "react";
// // import { Container, Row, Col, Image, Form } from "react-bootstrap";
// // import { FaEdit, FaSave } from "react-icons/fa";
// // import aboutImageDefault from "../profileimage/shoert.jpg";
// // import "./Bestdeals.css"

// // const Aboutmaamaas = () => {
// //   const [isTextEditing, setIsTextEditing] = useState(false);
// //   const [isImageEditing, setIsImageEditing] = useState(false);
// //   const [aboutText, setAboutText] = useState({ aboutUs: "" });
// //   const [previewImage, setPreviewImage] = useState(aboutImageDefault);
// //   const [imageFile, setImageFile] = useState(null);
// //   const [vendorId, setVendorId] = useState(null);
// //   const [aboutUsId, setAboutUsId] = useState(null);

// //   useEffect(() => {
// //     const storedVendorId = localStorage.getItem("vendorId");
// //     setVendorId(storedVendorId);
// //   }, []);

// //   useEffect(() => {
// //     if (vendorId) fetchAboutUsData(vendorId);
// //   }, [vendorId]);

// //   const fetchAboutUsData = async (vendorId) => {
// //     const token = localStorage.getItem("authToken");
// //     if (!token || !vendorId) return;

// //     try {
// //       const response = await fetch(
// //         `https://backend.maamaas.com/food/api/vendor/aboutus/get/${vendorId}`,
// //         { headers: { Authorization: `Bearer ${token}` } }
// //       );

// //       if (response.ok) {
// //         const data = await response.json();
// //         setAboutText({ aboutUs: data.aboutUs || "" });
// //         setAboutUsId(data.aboutUsId || null);

// //         if (data.image) {
// //           setPreviewImage(data.image);
// //         } else {
// //           setPreviewImage(aboutImageDefault);
// //         }
// //       }
// //     } catch (err) {
// //       console.error("Error fetching About Us:", err);
// //     }
// //   };

// //   const handleTextChange = (e) =>
// //     setAboutText({ ...aboutText, aboutUs: e.target.value });

// //   const handleImageChange = (e) => {
// //     const file = e.target.files[0];
// //     if (!file) return;
// //     setImageFile(file);

// //     const reader = new FileReader();
// //     reader.onloadend = () => setPreviewImage(reader.result);
// //     reader.readAsDataURL(file);
// //   };

// //   const sendFormData = async (url, method) => {
// //     const token = localStorage.getItem("authToken");
// //     if (!vendorId || !token) return alert("Vendor ID or auth token missing");

// //     if (!aboutText.aboutUs.trim()) return alert("Please enter About Us text");

// //     const formData = new FormData();

// //     // 🔹 If your backend expects 'aboutUsData' as JSON:
// //     formData.append(
// //       "aboutUsData",
// //       new Blob([JSON.stringify({ aboutUs: aboutText.aboutUs })], {
// //         type: "application/json",
// //       })
// //     );

// //     // 🔹 Image file if selected
// //     if (imageFile) {
// //       formData.append("image", imageFile);
// //     }

// //     for (const pair of formData.entries()) {
// //     }

// //     try {
// //       const response = await fetch(url, {
// //         method,
// //         headers: { Authorization: `Bearer ${token}` },
// //         body: formData,
// //       });

// //       if (response.ok) {
// //         alert(method === "POST" ? "Added successfully!" : "Updated successfully!");
// //         setIsTextEditing(false);
// //         setIsImageEditing(false);
// //         fetchAboutUsData(vendorId);
// //       } else {
// //         const err = await response.json();
// //         alert(`Failed: ${err.message || "Unknown error"}`);
// //       }
// //     } catch (error) {
// //       console.error("Error submitting form:", error);
// //       alert("Something went wrong. Please try again.");
// //     }
// //   };

// //   const handleAddAboutUs = async () => {
// //     const url = `https://backend.maamaas.com/food/api/vendor/aboutus/add/${vendorId}`;
// //     await sendFormData(url, "POST");
// //   };

// //   const handleTextEditSaveToggle = async () => {
// //     if (isTextEditing && aboutUsId) {
// //       const url = `https://backend.maamaas.com/food/api/vendor/aboutus/update/${aboutUsId}`;
// //       await sendFormData(url, "PUT");
// //     }
// //     setIsTextEditing((prev) => !prev);
// //   };

// //   const handleImageEditSaveToggle = async () => {
// //     if (isImageEditing && aboutUsId) {
// //       const url = `https://backend.maamaas.com/food/api/vendor/aboutus/update/${aboutUsId}`;
// //       await sendFormData(url, "PUT");
// //     }
// //     setIsImageEditing((prev) => !prev);
// //   };

// //   return (
// //     <Container fluid className="py-4">
// //       <Row
// //         style={{ border: "none", borderRadius: "20px", marginTop: "30px", backgroundColor: "#b15dc6" }}
// //         className="align-items-center"
// //       >
// //         <div className="d-flex w-100 px-4 pt-3"
// //           style={{

// //             justifyContent: "space-around",

// //           }}
// //         >
// //           <h1
// //             style={{
// //               color: "#ffffffff",
// //               fontWeight: "bold",
// //               textAlign: "center",
// //               marginBottom: "10px",
// //             }}
// //             className="abouts-page-name"
// //           >
// //             ABOUT US
// //           </h1>

// //           <button onClick={handleAddAboutUs} style={buttonStyle}>
// //             Add+
// //           </button>
// //         </div>

// //         {/* Combined Text and Image Section in a single div */}
// //         <div
// //           className="p-4 position-relative"
// //           style={{
// //             backgroundColor: "white",
// //             margin: "10px",
// //             borderRadius: "20px",
// //             display: "flex",
// //             flexDirection: "row",
// //             gap: "20px",
// //             width: "calc(100% - 20px)",
// //             alignItems: "center",
// //             justifyContent: "space-between",
// //           }}
// //         >
// //           {/* Text Section */}
// //           <div  style={{ width: "60%", 
// //             padding: "20px", borderRadius: "20px", backgroundColor:"#f5f4f4" }}>
// //             <div className="d-flex justify-content-between align-items-center mb-2"
// //             style={{marginTop:"-10px"}}>
// //               <h5 style={{ color: "#b15cd6", margin: 0 }}>About Text</h5>
// //               <button onClick={handleTextEditSaveToggle} style={sectionButtonStyle}>
// //                 {isTextEditing ? <FaSave /> : <FaEdit />}
// //               </button>
// //             </div>
// //             <Form.Control
// //               as="textarea"
// //               className="hide-scrollbar"
// //               rows={8}
// //               value={aboutText.aboutUs}
// //               onChange={handleTextChange}
// //               readOnly={!isTextEditing}
// //               placeholder="Write about us..."
// //               style={{
// //                 fontSize: "16px",
// //                 color: "#333",
// //                 lineHeight: "1.2",
// //                 textAlign: "justify",
// //                 border: "0px solid transparent !important",
// //                 boxShadow: "none !important",
// //                 fontFamily: "math",
// //                 resize: "none",
// //                 outline: "none",
// //                 width: "100%",
// //                 // backgroundColor: "#f3f8ffff"
// //                  backgroundColor:"#f5f4f4"
// //               }}
// //             />
// //           </div>

// //           {/* Image Section */}
// //           <div style={{
// //             width: "40%", padding: "20px 10px 10px 10px",
// //             borderRadius: "20px",
// //             marginTop:"-20px",
// //           }}>
// //             <div className="d-flex justify-content-between align-items-center mb-2">
// //               <h5 style={{ color: "#ffffffff", margin: 0 }}>About Image</h5>
// //               <button onClick={handleImageEditSaveToggle} style={sectionButtonStyle}>
// //                 {isTextEditing ? <FaSave /> : <FaEdit />}
// //               </button>
// //             </div>
// //             <div className="position-relative d-inline-block w-100">
// //               {isImageEditing && (
// //                 <input
// //                   type="file"
// //                   accept="image/*"
// //                   id="imageUpload"
// //                   style={{ display: "none" }}
// //                   onChange={handleImageChange}
// //                 />
// //               )}
// //               <label
// //                 htmlFor={isImageEditing ? "imageUpload" : ""}
// //                 style={{
// //                   cursor: isImageEditing ? "pointer" : "default",
// //                   width: "100%",
// //                   display: "block"
// //                 }}
// //               >
// //                 <Image
// //                   src={previewImage}
// //                   alt="About Maamaa's Restaurant"
// //                   fluid
// //                   rounded
// //                   style={{
// //                     width: "100%",
// //                     objectFit: "cover",
// //                     borderRadius: "12px",
// //                     height: "157px", // Reduced from 310px
// //                     maxHeight: "200px", // Reduced from 350px
// //                     marginTop: "0px",
// //                     boxShadow: "0 4px 16px rgba(0,0,0,0.1)",
// //                   }}
// //                 />
// //               </label>
// //             </div>
// //           </div>
// //         </div>
// //       </Row>
// //       <style>
// //   {`
// //     /* Hide scrollbar across all platforms */
// //     .hide-scrollbar::-webkit-scrollbar {
// //       display: none;
// //       width: 0;
// //       height: 0;
// //     }

// //     .hide-scrollbar {
// //       -ms-overflow-style: none;
// //       scrollbar-width: none;
// //     }

// //     /* Apply to your scrollable element */
// //     .your-scrollable-element {
// //       overflow: auto;
// //     }
// //   `}
// // </style>
// //     </Container>
// //   );
// // };

// // const buttonStyle = {
// //   height: "35px",
// //   borderRadius: "5px",
// //   border: "none",
// //   // background: "#b15cd6",
// //   color: "#b15cd6",
// //   fontWeight: "bold",
// //   cursor: "pointer",
// //   width: "80px",
// //   marginLeft: "20px",
// //   marginTop: "8px",
// //   display: "flex",
// //   alignItems: "center",
// //   justifyContent: "center",
// //   gap: "5px",
// // };

// // const sectionButtonStyle = {
// //   height: "25px",
// //   borderRadius: "50%",
// //   border: "none",
// //   background: "#b15cd6",
// //   color: "#fff",
// //   fontWeight: "bold",
// //   cursor: "pointer",
// //   width: "auto",
// //   display: "flex",
// //   alignItems: "center",
// //   justifyContent: "center",
// //   gap: "5px",
// // };

// // export default Aboutmaamaas;


// // import React, { useState, useEffect, useRef } from "react";
// // import { Container, Row, Col, Image, Form } from "react-bootstrap";
// // import { FaEdit, FaSave, FaEllipsisV } from "react-icons/fa";
// // import aboutImageDefault from "../profileimage/shoert.jpg";
// // import "./Bestdeals.css"

// // const Aboutmaamaas = () => {
// //   const [isTextEditing, setIsTextEditing] = useState(false);
// //   const [isImageEditing, setIsImageEditing] = useState(false);
// //   const [aboutText, setAboutText] = useState({ aboutUs: "" });
// //   const [previewImage, setPreviewImage] = useState(aboutImageDefault);
// //   const [imageFile, setImageFile] = useState(null);
// //   const [vendorId, setVendorId] = useState(null);
// //   const [aboutUsId, setAboutUsId] = useState(null);
// //   const [showTextEditButton, setShowTextEditButton] = useState(false);
// //   const [showImageEditButton, setShowImageEditButton] = useState(false);
// //   const [showThreeDots, setShowThreeDots] = useState(true);
// //   const [showEditOptions, setShowEditOptions] = useState(false);

// //   const timeoutRef = useRef(null);

// //   useEffect(() => {
// //     const storedVendorId = localStorage.getItem("vendorId");
// //     setVendorId(storedVendorId);
// //   }, []);

// //   useEffect(() => {
// //     if (vendorId) fetchAboutUsData(vendorId);
// //   }, [vendorId]);

// //   // Auto-hide edit buttons after 5 seconds
// //   useEffect(() => {
// //     if (showTextEditButton || showImageEditButton) {
// //       // Clear existing timeout
// //       if (timeoutRef.current) {
// //         clearTimeout(timeoutRef.current);
// //       }

// //       // Set new timeout
// //       timeoutRef.current = setTimeout(() => {
// //         setShowTextEditButton(false);
// //         setShowImageEditButton(false);
// //         setShowThreeDots(true);
// //         setShowEditOptions(false);
// //       }, 5000); // 5 seconds
// //     }

// //     // Cleanup timeout on unmount
// //     return () => {
// //       if (timeoutRef.current) {
// //         clearTimeout(timeoutRef.current);
// //       }
// //     };
// //   }, [showTextEditButton, showImageEditButton]);

// //   const fetchAboutUsData = async (vendorId) => {
// //     const token = localStorage.getItem("authToken");
// //     if (!token || !vendorId) return;

// //     try {
// //       const response = await fetch(
// //         `https://backend.maamaas.com/food/api/vendor/aboutus/get/${vendorId}`,
// //         { headers: { Authorization: `Bearer ${token}` } }
// //       );

// //       if (response.ok) {
// //         const data = await response.json();
// //         setAboutText({ aboutUs: data.aboutUs || "" });
// //         setAboutUsId(data.aboutUsId || null);

// //         if (data.image) {
// //           setPreviewImage(data.image);
// //         } else {
// //           setPreviewImage(aboutImageDefault);
// //         }
// //       }
// //     } catch (err) {
// //       console.error("Error fetching About Us:", err);
// //     }
// //   };

// //   const handleTextChange = (e) =>
// //     setAboutText({ ...aboutText, aboutUs: e.target.value });

// //   const handleImageChange = (e) => {
// //     const file = e.target.files[0];
// //     if (!file) return;
// //     setImageFile(file);

// //     const reader = new FileReader();
// //     reader.onloadend = () => setPreviewImage(reader.result);
// //     reader.readAsDataURL(file);
// //   };

// //   const sendFormData = async (url, method) => {
// //     const token = localStorage.getItem("authToken");
// //     if (!vendorId || !token) return alert("Vendor ID or auth token missing");

// //     if (!aboutText.aboutUs.trim()) return alert("Please enter About Us text");

// //     const formData = new FormData();

// //     // 🔹 If your backend expects 'aboutUsData' as JSON:
// //     formData.append(
// //       "aboutUsData",
// //       new Blob([JSON.stringify({ aboutUs: aboutText.aboutUs })], {
// //         type: "application/json",
// //       })
// //     );

// //     // 🔹 Image file if selected
// //     if (imageFile) {
// //       formData.append("image", imageFile);
// //     }

// //     for (const pair of formData.entries()) {
// //     }

// //     try {
// //       const response = await fetch(url, {
// //         method,
// //         headers: { Authorization: `Bearer ${token}` },
// //         body: formData,
// //       });

// //       if (response.ok) {
// //         alert(method === "POST" ? "Added successfully!" : "Updated successfully!");
// //         setIsTextEditing(false);
// //         setIsImageEditing(false);
// //         fetchAboutUsData(vendorId);
// //       } else {
// //         const err = await response.json();
// //         alert(`Failed: ${err.message || "Unknown error"}`);
// //       }
// //     } catch (error) {
// //       console.error("Error submitting form:", error);
// //       alert("Something went wrong. Please try again.");
// //     }
// //   };

// //   const handleAddAboutUs = async () => {
// //     const url = `https://backend.maamaas.com/food/api/vendor/aboutus/add/${vendorId}`;
// //     await sendFormData(url, "POST");
// //   };

// //   const handleTextEditSaveToggle = async () => {
// //     if (isTextEditing && aboutUsId) {
// //       const url = `https://backend.maamaas.com/food/api/vendor/aboutus/update/${aboutUsId}`;
// //       await sendFormData(url, "PUT");
// //     }
// //     setIsTextEditing((prev) => !prev);
// //     // Reset the auto-hide timer when editing
// //     setShowTextEditButton(true);
// //   };

// //   const handleImageEditSaveToggle = async () => {
// //     if (isImageEditing && aboutUsId) {
// //       const url = `https://backend.maamaas.com/food/api/vendor/aboutus/update/${aboutUsId}`;
// //       await sendFormData(url, "PUT");
// //     }
// //     setIsImageEditing((prev) => !prev);
// //     // Reset the auto-hide timer when editing
// //     setShowImageEditButton(true);
// //   };

// //   const handleThreeDotsClick = () => {
// //     setShowThreeDots(false);
// //     setShowEditOptions(true);
// //   };

// //   const handleEditTextClick = () => {
// //     setShowEditOptions(false);
// //     setShowTextEditButton(true);
// //   };

// //   const handleEditImageClick = () => {
// //     setShowEditOptions(false);
// //     setShowImageEditButton(true);
// //   };

// //   return (
// //     <Container fluid className="py-4">
// //       <Row
// //         style={{ border: "none", borderRadius: "20px", marginTop: "30px", backgroundColor: "#b15dc6" }}
// //         className="align-items-center"
// //       >
// //         <div className="d-flex w-100 px-4 pt-3"
// //           style={{
// //             justifyContent: "space-around",
// //           }}
// //         >
// //           <h1
// //             style={{
// //               color: "#ffffffff",
// //               fontWeight: "bold",
// //               textAlign: "center",
// //               marginBottom: "10px",
// //             }}
// //             className="abouts-page-name"
// //           >
// //             ABOUT US
// //           </h1>

// //           <button onClick={handleAddAboutUs} style={buttonStyle}>
// //             Add+
// //           </button>
// //         </div>

// //         {/* Combined Text and Image Section in a single div */}
// //         <div
// //           className="p-4 position-relative"
// //           style={{
// //             backgroundColor: "white",
// //             margin: "10px",
// //             borderRadius: "20px",
// //             display: "flex",
// //             flexDirection: "row",
// //             gap: "20px",
// //             width: "calc(100% - 20px)",
// //             alignItems: "center",
// //             justifyContent: "space-between",
// //           }}
// //         >
// //           {/* Three Dots Button */}
// //           {showThreeDots && (
// //             <button 
// //               onClick={handleThreeDotsClick}
// //               style={threeDotsStyle}
// //               title="Toggle edit buttons"
// //             >
// //               <FaEllipsisV />
// //             </button>
// //           )}

// //           {/* Edit Options (Edit Text & Edit Image buttons) */}
// //           {showEditOptions && (
// //             <div style={editOptionsStyle}>
// //               <button onClick={handleEditTextClick} style={editOptionButtonStyle}>
// //                 Edit Text
// //               </button>
// //               <button onClick={handleEditImageClick} style={editOptionButtonStyle}>
// //                 Edit Image
// //               </button>
// //             </div>
// //           )}

// //           {/* Text Section */}
// //           <div  style={{ width: "60%", 
// //             padding: "20px", borderRadius: "20px", backgroundColor:"#f5f4f4" }}>
// //             <div className="d-flex justify-content-between align-items-center mb-2"
// //             style={{marginTop:"-10px"}}>
// //               <h5 style={{ color: "#b15cd6", margin:"5px" }}>About Text</h5>
// //               {showTextEditButton && (
// //                 <button onClick={handleTextEditSaveToggle} style={sectionButtonStyle}>
// //                   {isTextEditing ? <FaSave /> : <FaEdit />}
// //                 </button>
// //               )}
// //             </div>
// //             <Form.Control
// //               as="textarea"
// //               className="hide-scrollbar"
// //               rows={8}
// //               value={aboutText.aboutUs}
// //               onChange={handleTextChange}
// //               readOnly={!isTextEditing}
// //               placeholder="Write about us..."
// //               style={{
// //                 fontSize: "16px",
// //                 color: "#333",
// //                 lineHeight: "1.2",
// //                 textAlign: "justify",
// //                 border: "0px solid transparent !important",
// //                 boxShadow: "none !important",
// //                 fontFamily: "math",
// //                 resize: "none",
// //                 outline: "none",
// //                 width: "100%",
// //                 backgroundColor:"#f5f4f4"
// //               }}
// //             />
// //           </div>

// //           {/* Image Section */}
// //           <div style={{
// //             width: "40%", padding: "20px 10px 10px 10px",
// //             borderRadius: "20px",
// //             marginTop:"-20px",
// //           }}>
// //             <div className="d-flex justify-content-between align-items-center mb-2">
// //               <h5 style={{ color: "#b15cd6", margin: "5px" }}>About Image</h5>
// //               {showImageEditButton && (
// //                 <button onClick={handleImageEditSaveToggle} style={sectionButtonStyle}>
// //                   {isImageEditing ? <FaSave /> : <FaEdit />}
// //                 </button>
// //               )}
// //             </div>
// //             <div className="position-relative d-inline-block w-100">
// //               {isImageEditing && (
// //                 <input
// //                   type="file"
// //                   accept="image/*"
// //                   id="imageUpload"
// //                   style={{ display: "none" }}
// //                   onChange={handleImageChange}
// //                 />
// //               )}
// //               <label
// //                 htmlFor={isImageEditing ? "imageUpload" : ""}
// //                 style={{
// //                   cursor: isImageEditing ? "pointer" : "default",
// //                   width: "100%",
// //                   display: "block"
// //                 }}
// //               >
// //                 <Image
// //                   src={previewImage}
// //                   alt="About Maamaa's Restaurant"
// //                   fluid
// //                   rounded
// //                   style={{
// //                     width: "100%",
// //                     objectFit: "cover",
// //                     borderRadius: "12px",
// //                     height: "157px", // Reduced from 310px
// //                     maxHeight: "200px", // Reduced from 350px
// //                     marginTop: "0px",
// //                     boxShadow: "0 4px 16px rgba(0,0,0,0.1)",
// //                   }}
// //                 />
// //               </label>
// //             </div>
// //           </div>
// //         </div>
// //       </Row>
// //       <style>
// //   {`
// //     /* Hide scrollbar across all platforms */
// //     .hide-scrollbar::-webkit-scrollbar {
// //       display: none;
// //       width: 0;
// //       height: 0;
// //     }

// //     .hide-scrollbar {
// //       -ms-overflow-style: none;
// //       scrollbar-width: none;
// //     }

// //     /* Apply to your scrollable element */
// //     .your-scrollable-element {
// //       overflow: auto;
// //     }
// //   `}
// // </style>
// //     </Container>
// //   );
// // };

// // const buttonStyle = {
// //   height: "35px",
// //   borderRadius: "5px",
// //   border: "none",
// //   color: "#b15cd6",
// //   fontWeight: "bold",
// //   cursor: "pointer",
// //   width: "80px",
// //   marginLeft: "20px",
// //   marginTop: "8px",
// //   display: "flex",
// //   alignItems: "center",
// //   justifyContent: "center",
// //   gap: "5px",
// // };

// // const sectionButtonStyle = {
// //   height: "25px",
// //   borderRadius: "50%",
// //   border: "none",
// //   background: "#b15cd6",
// //   color: "#fff",
// //   fontWeight: "bold",
// //   cursor: "pointer",
// //   width: "auto",
// //   display: "flex",
// //   alignItems: "center",
// //   justifyContent: "center",
// //   gap: "5px",
// // };

// // const threeDotsStyle = {
// //   position: "absolute",
// //   top: "10px",
// //   right: "10px",
// //   background: "transparent",
// //   border: "none",
// //   color: "#b15cd6",
// //   cursor: "pointer",
// //   fontSize: "18px",
// //   padding: "5px",
// //   borderRadius: "50%",
// //   zIndex: 10,
// // };

// // const editOptionsStyle = {
// //   position: "absolute",
// //   top: "10px",
// //   right: "10px",
// //   background: "white",
// //   border: "1px solid #b15cd6",
// //   borderRadius: "8px",
// //   padding: "8px",
// //   display: "flex",
// //   flexDirection: "column",
// //   gap: "5px",
// //   boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
// //   zIndex: 10,
// // };

// // const editOptionButtonStyle = {
// //   background: "transparent",
// //   border: "none",
// //   color: "#b15cd6",
// //   cursor: "pointer",
// //   fontSize: "14px",
// //   padding: "5px 10px",
// //   borderRadius: "4px",
// //   textAlign: "left",
// //   fontWeight: "500",
// // };

// // export default Aboutmaamaas;




// import React, { useState, useEffect, useRef } from "react";
// import { Container, Row, Image, Form } from "react-bootstrap";
// import aboutImageDefault from "../profileimage/shoert.jpg";
// import "./Bestdeals.css";

// const Aboutmaamaas = () => {
//   const [aboutText, setAboutText] = useState({ aboutUs: "" });
//   const [previewImage, setPreviewImage] = useState(aboutImageDefault);
//   const [imageFile, setImageFile] = useState(null);
//   const [vendorId, setVendorId] = useState(null);
//   const [aboutUsId, setAboutUsId] = useState(null);

//   // Editing states
//   const [isTextEditing, setIsTextEditing] = useState(false);
//   const [isImageEditing, setIsImageEditing] = useState(false);

//   // ref for hidden file input
//   const fileInputRef = useRef(null);

//   // Responsive state
//   const [windowWidth, setWindowWidth] = useState(window.innerWidth);
//   const isMobile = windowWidth <= 768;
//   const isTablet = windowWidth > 768 && windowWidth <= 1024;

//   useEffect(() => {
//     const handleResize = () => setWindowWidth(window.innerWidth);
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   useEffect(() => {
//     const storedVendorId = localStorage.getItem("vendorId");
//     setVendorId(storedVendorId);
//   }, []);

//   useEffect(() => {
//     if (vendorId) fetchAboutUsData(vendorId);
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [vendorId]);

//   const fetchAboutUsData = async () => {
//     const token = localStorage.getItem("authToken");
//     if (!token || !vendorId) return;

//     try {
//       const response = await fetch(
//         `https://backend.maamaas.com/food/api/vendor/aboutus/get/${vendorId}`,
//         { headers: { Authorization: `Bearer ${token}` } }
//       );

//       if (response.ok) {
//         const data = await response.json();
//         setAboutText({ aboutUs: data.aboutUs || "" });
//         setAboutUsId(data.aboutUsId || null);

//         if (data.image) {
//           setPreviewImage(data.image);
//         } else {
//           setPreviewImage(aboutImageDefault);
//         }
//       }
//     } catch (err) {
//       console.error("Error fetching About Us:", err);
//     }
//   };

//   const handleTextChange = (e) => {
//     setAboutText((prev) => ({ ...prev, aboutUs: e.target.value }));
//   };

//   const handleImageChange = (e) => {
//     const file = e.target.files?.[0];
//     if (!file) return;
//     setImageFile(file);

//     const reader = new FileReader();
//     reader.onloadend = () => setPreviewImage(reader.result);
//     reader.readAsDataURL(file);
//   };

//   const sendFormData = async (url, method) => {
//     const token = localStorage.getItem("authToken");
//     if (!vendorId || !token) return alert("Vendor ID or auth token missing");

//     if (!aboutText.aboutUs?.trim()) {
//       return alert("Please enter About Us text");
//     }

//     const formData = new FormData();

//     formData.append(
//       "aboutUsData",
//       new Blob([JSON.stringify({ aboutUs: aboutText.aboutUs })], {
//         type: "application/json",
//       })
//     );

//     if (imageFile) {
//       formData.append("image", imageFile);
//     }

//     try {
//       const response = await fetch(url, {
//         method,
//         headers: { Authorization: `Bearer ${token}` },
//         body: formData,
//       });

//       if (response.ok) {
//         alert(method === "POST" ? "Added successfully!" : "Updated successfully!");
//         await fetchAboutUsData();
//         setIsTextEditing(false);
//         setIsImageEditing(false);
//         setImageFile(null);
//         return true;
//       } else {
//         const err = await response.json().catch(() => ({}));
//         alert(`Failed: ${err.message || "Unknown error"}`);
//         return false;
//       }
//     } catch (error) {
//       console.error("Error submitting form:", error);
//       alert("Something went wrong. Please try again.");
//       return false;
//     }
//   };

//   const handleAddAboutUs = () => {
//     const url = `https://backend.maamaas.com/food/api/vendor/aboutus/add/${vendorId}`;
//     sendFormData(url, "POST");
//   };

//   const handleUpdate = () => {
//     if (!aboutUsId) return alert("No record to update");

//     const url = `https://backend.maamaas.com/food/api/vendor/aboutus/update/${aboutUsId}`;
//     sendFormData(url, "PUT");
//   };

//   const handleImageClick = () => {
//     if (isImageEditing && fileInputRef.current) {
//       fileInputRef.current.click();
//     }
//   };

//   // Responsive styles
//   const getContainerPadding = () => {
//     if (isMobile) return "2vh 1vw";
//     if (isTablet) return "3vh 2vw";
//     return "4vh 3vw";
//   };

//   const getTextAreaRows = () => {
//     if (isMobile) return 6;
//     if (isTablet) return 8;
//     return 10;
//   };

//   const getImageHeight = () => {
//     if (isMobile) return "200px";
//     if (isTablet) return "240px";
//     return "280px";
//   };

//   const getFontSize = () => {
//     if (isMobile) return "14px";
//     if (isTablet) return "15px";
//     return "16px";
//   };

//   const getHeadingSize = () => {
//     if (isMobile) return "20px";
//     if (isTablet) return "24px";
//     return "28px";
//   };

//   return (
//     <Container fluid className="py-4">
//       {/* HEADER SECTION */}
//       <Row
//         style={{
//           border: "none",
//           borderRadius: "2vmin",
//           marginTop: isMobile ? "2vh" : "4vh",
//           backgroundColor: "#b15dc6",
//         }}
//         className="align-items-center addmargintop"
//       >
//         <div
//           className="d-flex w-100 px-3 px-md-4 pt-3"
//           style={{ 
//             justifyContent: "space-between",
//             flexDirection: isMobile ? "row" : "row",
//             gap: isMobile ? "10px" : "0"
//           }}
//         >
//           <h1
//             style={{
//               color: "#ffffff",
//               fontWeight: "bold",
//               marginBottom: isMobile ? "5px" : "10px",
//               fontSize: getHeadingSize(),
//               textAlign: isMobile ? "center" : "left",
//               marginLeft:"10px",
//             }}
//             className="abouts-page-name"
//           >
//             ABOUT US
//           </h1>

//           <button onClick={handleAddAboutUs} style={{
//             height: isMobile ? "30px" : "35px",
//             borderRadius: "5px",
//             border: "none",
//             color: "#b15cd6",
//             fontWeight: "bold",
//             cursor: "pointer",
//             width: isMobile ? "70px" : "80px",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             fontSize: isMobile ? "12px" : "14px",
//             marginRight:"10px",
//           }}>
//             Add+
//           </button>
//         </div>

//         {/* MAIN CONTENT CARD */}
//         <div
//           className="p-3 p-md-4"
//           style={{
//             backgroundColor: "#b15dc6",
//             margin: isMobile ? "5px" : "10px",
//             borderRadius: "2vmin",
//             display: "flex",
//             flexDirection: isMobile ? "column" : "row",
//             gap: isMobile ? "15px" : "20px",
//             width: isMobile ? "calc(100% - 10px)" : "calc(100% - 20px)",
//             justifyContent: "space-between",
//           }}
//         >
//           {/* TEXT SECTION */}
//           <div style={{
//             backgroundColor: "white",
//             borderRadius: "2vmin",
//             padding: isMobile ? "15px" : "20px",
//             width: isMobile ? "100%" : "40%",
//             boxShadow: "0 0.4vmin 1.6vmin rgba(0,0,0,0.1)",
//           }}>
//             <div className="d-flex justify-content-between align-items-center mb-2">
//               <h5 style={{ 
//                 color: "#ffffffff",
//                 fontSize: isMobile ? "16px" : "18px",
                
//               }}>Our Story</h5>

//               {/* EDIT/SAVE BUTTONS */}
//               {!isTextEditing ? (
//                 <button onClick={() => setIsTextEditing(true)} style={{
//                   border: "none",
//                   background: "#ffffff",
//                   color: "#b15cd6",
//                   fontWeight: "bold",
//                   cursor: "pointer",
//                   padding: isMobile ? "4px 8px" : "5px 10px",
//                   borderRadius: "0.6vmin",
//                   border: "1px solid #b15cd6",
//                   fontSize: isMobile ? "12px" : "14px"
//                 }}>
//                   Edit Text
//                 </button>
//               ) : (
//                 <button onClick={handleUpdate} style={{
//                   background: "#b15cd6",
//                   border: "none",
//                   padding: isMobile ? "4px 10px" : "5px 12px",
//                   borderRadius: "0.6vmin",
//                   color: "#fff",
//                   fontWeight: "bold",
//                   cursor: "pointer",
//                   fontSize: isMobile ? "12px" : "14px"
//                 }}>
//                   Save
//                 </button>
//               )}
//             </div>

//             <Form.Control
//               as="textarea"
//               rows={getTextAreaRows()}
//               className="hide-scrollbar"
//               value={aboutText.aboutUs}
//               onChange={handleTextChange}
//               readOnly={!isTextEditing}
//               placeholder="Write about us..."
//               style={{
//                 fontSize: getFontSize(),
//                 color: "#333",
//                 textAlign: "justify",
//                 border: isTextEditing ? "0.2vmin solid #b15cd6" : "0px",
//                 boxShadow: isTextEditing ? "0 0 0 0.3vmin rgba(177, 92, 214, 0.1)" : "none",
//                 backgroundColor: isTextEditing ? "white" : "#f5f4f4",
//                 borderRadius: "0.8vmin",
//                 padding: isMobile ? "8px" : "10px",
//                 resize: "none",
//                 fontFamily: "math",
//                 transition: "all 0.3s ease",
//                 width: "100%"
//               }}
//             />
//           </div>

//           {/* IMAGE SECTION */}
//           <div style={{
//             backgroundColor: "white",
//             borderRadius: "2vmin",
//             padding: isMobile ? "15px" : "20px",
//             width: isMobile ? "100%" : "55%",
//             boxShadow: "0 0.4vmin 1.6vmin rgba(0,0,0,0.1)",
//           }}>
//             <div className="d-flex justify-content-between align-items-center mb-2">
//               <h5 style={{ 
//                 color: "#ffffffff",
//                 fontSize: isMobile ? "16px" : "18px"
//               }}>Our Space</h5>

//               {!isImageEditing ? (
//                 <button onClick={() => setIsImageEditing(true)} style={{
//                   border: "none",
//                   background: "#ffffff",
//                   color: "#b15cd6",
//                   fontWeight: "bold",
//                   cursor: "pointer",
//                   padding: isMobile ? "4px 8px" : "5px 10px",
//                   borderRadius: "0.6vmin",
//                   border: "1px solid #b15cd6",
//                   fontSize: isMobile ? "12px" : "14px"
//                 }}>
//                   Edit Image
//                 </button>
//               ) : (
//                 <button onClick={handleUpdate} style={{
//                   background: "#b15cd6",
//                   border: "none",
//                   padding: isMobile ? "4px 10px" : "5px 12px",
//                   borderRadius: "0.6vmin",
//                   color: "#fff",
//                   fontWeight: "bold",
//                   cursor: "pointer",
//                   fontSize: isMobile ? "12px" : "14px"
//                 }}>
//                   Save
//                 </button>
//               )}
//             </div>

//             <div>
//               <input
//                 ref={fileInputRef}
//                 type="file"
//                 accept="image/*"
//                 onChange={handleImageChange}
//                 style={{ display: "none" }}
//               />

//               <div
//                 onClick={handleImageClick}
//                 role={isImageEditing ? "button" : undefined}
//                 tabIndex={isImageEditing ? 0 : undefined}
//                 onKeyPress={(e) => {
//                   if (isImageEditing && (e.key === "Enter" || e.key === " ")) {
//                     handleImageClick();
//                   }
//                 }}
//                 style={{ cursor: isImageEditing ? "pointer" : "default" }}
//               >
//                 <Image
//                   src={previewImage}
//                   alt="About Us"
//                   fluid
//                   rounded
//                   style={{
//                     width: "100%",
//                     height: getImageHeight(),
//                     objectFit: "cover",
//                     borderRadius: "1.2vmin",
//                     border: isImageEditing ? "0.2vmin solid #b15cd6" : "none",
//                   }}
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </Row>

//       {/* HIDE SCROLLBAR CSS */}
//       <style>
//         {`
//           .hide-scrollbar::-webkit-scrollbar {
//             display: none;
//           }
//           .hide-scrollbar {
//             scrollbar-width: none;
//           }
          
//           @media (max-width: 768px) {
//             .px-md-4 {
//               padding-left: 1rem !important;
//               padding-right: 1rem !important;
//             }
//             .p-md-4 {
//               padding: 1.5rem !important;
//             }
//           }
          
//           @media (max-width: 480px) {
//             .abouts-page-name {
//               font-size: 18px !important;
//             }
//           }
//             @media(max-width:768px) {
//             .addmargintop{
//             margin-top:2vh !important;
//             }                  
//             }
            
//         `}
//       </style>
//     </Container>
//   );
// };

// export default Aboutmaamaas;




import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Image, Form } from "react-bootstrap";
import aboutImageDefault from "../profileimage/shoert.jpg";
import "./Bestdeals.css";

const Aboutmaamaas = () => {
  const [aboutText, setAboutText] = useState({ aboutUs: "" });
  const [previewImage, setPreviewImage] = useState(aboutImageDefault);
  const [imageFile, setImageFile] = useState(null);
  const [vendorId, setVendorId] = useState(null);
  const [aboutUsId, setAboutUsId] = useState(null);

  // Editing states
  const [isTextEditing, setIsTextEditing] = useState(false);
  const [isImageEditing, setIsImageEditing] = useState(false);

  // ref for hidden file input
  const fileInputRef = useRef(null);

  // Responsive state
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const isMobile = windowWidth <= 768;
  const isTablet = windowWidth > 768 && windowWidth <= 1024;

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const storedVendorId = localStorage.getItem("vendorId");
    setVendorId(storedVendorId);
  }, []);

  useEffect(() => {
    if (vendorId) fetchAboutUsData(vendorId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vendorId]);

  const fetchAboutUsData = async () => {
    const token = localStorage.getItem("authToken");
    if (!token || !vendorId) return;

    try {
      const response = await fetch(
        `https://backend.maamaas.com/food/api/vendor/aboutus/get/${vendorId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response.ok) {
        const data = await response.json();
        setAboutText({ aboutUs: data.aboutUs || "" });
        setAboutUsId(data.aboutUsId || null);

        if (data.image) {
          setPreviewImage(data.image);
        } else {
          setPreviewImage(aboutImageDefault);
        }
      }
    } catch (err) {
      console.error("Error fetching About Us:", err);
    }
  };

  const handleTextChange = (e) => {
    setAboutText((prev) => ({ ...prev, aboutUs: e.target.value }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setImageFile(file);

    const reader = new FileReader();
    reader.onloadend = () => setPreviewImage(reader.result);
    reader.readAsDataURL(file);
  };

  const sendFormData = async (url, method) => {
    const token = localStorage.getItem("authToken");
    if (!vendorId || !token) return alert("Vendor ID or auth token missing");

    if (!aboutText.aboutUs?.trim()) {
      return alert("Please enter About Us text");
    }

    const formData = new FormData();

    formData.append(
      "aboutUsData",
      new Blob([JSON.stringify({ aboutUs: aboutText.aboutUs })], {
        type: "application/json",
      })
    );

    if (imageFile) {
      formData.append("image", imageFile);
    }

    try {
      const response = await fetch(url, {
        method,
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });

      if (response.ok) {
        alert(method === "POST" ? "Added successfully!" : "Updated successfully!");
        await fetchAboutUsData();
        setIsTextEditing(false);
        setIsImageEditing(false);
        setImageFile(null);
        return true;
      } else {
        const err = await response.json().catch(() => ({}));
        alert(`Failed: ${err.message || "Unknown error"}`);
        return false;
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Something went wrong. Please try again.");
      return false;
    }
  };

  const handleAddAboutUs = () => {
    const url = `https://backend.maamaas.com/food/api/vendor/aboutus/add/${vendorId}`;
    sendFormData(url, "POST");
  };

  const handleUpdate = () => {
    if (!aboutUsId) return alert("No record to update");

    const url = `https://backend.maamaas.com/food/api/vendor/aboutus/update/${aboutUsId}`;
    sendFormData(url, "PUT");
  };

  const handleImageClick = () => {
    if (isImageEditing && fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  // Responsive styles
  const getContainerPadding = () => {
    if (isMobile) return "2vh 1vw";
    if (isTablet) return "3vh 2vw";
    return "4vh 3vw";
  };

  const getTextAreaRows = () => {
    if (isMobile) return 6;
    if (isTablet) return 8;
    return 10;
  };

  const getImageHeight = () => {
    if (isMobile) return "200px";
    if (isTablet) return "240px";
    return "280px";
  };

  const getFontSize = () => {
    if (isMobile) return "14px";
    if (isTablet) return "15px";
    return "16px";
  };

  const getHeadingSize = () => {
    if (isMobile) return "20px";
    if (isTablet) return "24px";
    return "28px";
  };

  return (
    <Container fluid className="py-4">
      {/* HEADER SECTION */}
      <Row
        style={{
          border: "none",
          borderRadius: "2vmin",
          marginTop: isMobile ? "2vh" : "4vh",
          backgroundColor: "#b15dc6",
        }}
        className="align-items-center addmargintop"
      >
        <div
          className="d-flex w-100 px-3 px-md-4 pt-3"
          style={{ 
            justifyContent: "space-between",
            flexDirection: isMobile ? "row" : "row",
            gap: isMobile ? "10px" : "0",
          }}
        >
          <h1
            style={{
              color: "#ffffff",
              fontWeight: "bold",
              marginBottom: isMobile ? "5px" : "10px",
              fontSize: getHeadingSize(),
              textAlign: isMobile ? "center" : "left",
              marginLeft:"10px"
            }}
            className="abouts-page-name"
          >
            ABOUT US
          </h1>

          <button onClick={handleAddAboutUs} style={{
            height: isMobile ? "30px" : "35px",
            borderRadius: "5px",
            border: "none",
            color: "#b15cd6",
            fontWeight: "bold",
            cursor: "pointer",
            width: isMobile ? "70px" : "80px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: isMobile ? "12px" : "14px",
            marginRight:"10px",
          }}>
            Add+
          </button>
        </div>

        {/* MAIN CONTENT CARD */}
        <div
          className="p-3 p-md-4"
          style={{
            backgroundColor: "#b15dc6",
            margin: isMobile ? "5px" : "10px",
            borderRadius: "2vmin",
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            gap: isMobile ? "15px" : "20px",
            width: isMobile ? "calc(100% - 10px)" : "calc(100% - 20px)",
            justifyContent: "space-between",
            marginTop:"0px",

          }}
        >
          {/* TEXT SECTION */}
          <div style={{
            backgroundColor: "white",
            borderRadius: "2vmin",
            padding: isMobile ? "15px" : "20px",
            width: isMobile ? "100%" : "40%",
            boxShadow: "0 0.4vmin 1.6vmin rgba(0,0,0,0.1)",
          }}>
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h5 style={{ 
                color: "#ffffffff",
                fontSize: isMobile ? "16px" : "18px",
                
              }}>Our Story</h5>

              {/* EDIT/SAVE BUTTONS */}
              {!isTextEditing ? (
                <button onClick={() => setIsTextEditing(true)} style={{
                  border: "none",
                  background: "#ffffff",
                  color: "#b15cd6",
                  fontWeight: "bold",
                  cursor: "pointer",
                  padding: isMobile ? "4px 8px" : "5px 10px",
                  borderRadius: "0.6vmin",
                  border: "1px solid #b15cd6",
                  fontSize: isMobile ? "12px" : "14px"
                }}>
                  Edit Text
                </button>
              ) : (
                <button onClick={handleUpdate} style={{
                  background: "#b15cd6",
                  border: "none",
                  padding: isMobile ? "4px 10px" : "5px 12px",
                  borderRadius: "0.6vmin",
                  color: "#fff",
                  fontWeight: "bold",
                  cursor: "pointer",
                  fontSize: isMobile ? "12px" : "14px"
                }}>
                  Save
                </button>
              )}
            </div>

            <Form.Control
              as="textarea"
              rows={getTextAreaRows()}
              className="hide-scrollbar"
              value={aboutText.aboutUs}
              onChange={handleTextChange}
              readOnly={!isTextEditing}
              placeholder="Write about us..."
              style={{
                fontSize: getFontSize(),
                color: "#333",
                textAlign: "justify",
                border: isTextEditing ? "0.2vmin solid #b15cd6" : "0px",
                boxShadow: isTextEditing ? "0 0 0 0.3vmin rgba(177, 92, 214, 0.1)" : "none",
                backgroundColor: isTextEditing ? "white" : "#f5f4f4",
                borderRadius: "0.8vmin",
                padding: isMobile ? "8px" : "10px",
                resize: "none",
                fontFamily: "math",
                transition: "all 0.3s ease",
                width: "100%"
              }}
            />
          </div>

          {/* IMAGE SECTION */}
          <div style={{
            backgroundColor: "white",
            borderRadius: "2vmin",
            padding: isMobile ? "15px" : "20px",
            width: isMobile ? "100%" : "55%",
            boxShadow: "0 0.4vmin 1.6vmin rgba(0,0,0,0.1)",
          }}>
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h5 style={{ 
                color: "#ffffffff",
                fontSize: isMobile ? "16px" : "18px"
              }}>Our Space</h5>

              {!isImageEditing ? (
                <button onClick={() => setIsImageEditing(true)} style={{
                  border: "none",
                  background: "#ffffff",
                  color: "#b15cd6",
                  fontWeight: "bold",
                  cursor: "pointer",
                  padding: isMobile ? "4px 8px" : "5px 10px",
                  borderRadius: "0.6vmin",
                  border: "1px solid #b15cd6",
                  fontSize: isMobile ? "12px" : "14px"
                }}>
                  Edit Image
                </button>
              ) : (
                <button onClick={handleUpdate} style={{
                  background: "#b15cd6",
                  border: "none",
                  padding: isMobile ? "4px 10px" : "5px 12px",
                  borderRadius: "0.6vmin",
                  color: "#fff",
                  fontWeight: "bold",
                  cursor: "pointer",
                  fontSize: isMobile ? "12px" : "14px"
                }}>
                  Save
                </button>
              )}
            </div>

            <div>
              <input
                ref={fileInputRef}
                type="file"
                accept="image/*"
                onChange={handleImageChange}
                style={{ display: "none" }}
              />

              <div
                onClick={handleImageClick}
                role={isImageEditing ? "button" : undefined}
                tabIndex={isImageEditing ? 0 : undefined}
                onKeyPress={(e) => {
                  if (isImageEditing && (e.key === "Enter" || e.key === " ")) {
                    handleImageClick();
                  }
                }}
                style={{ cursor: isImageEditing ? "pointer" : "default" }}
              >
                <Image
                  src={previewImage}
                  alt="About Us"
                  fluid
                  rounded
                  style={{
                    width: "100%",
                    height: getImageHeight(),
                    objectFit: "cover",
                    borderRadius: "1.2vmin",
                    border: isImageEditing ? "0.2vmin solid #b15cd6" : "none",
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </Row>

      {/* HIDE SCROLLBAR CSS */}
      <style>
        {`
          .hide-scrollbar::-webkit-scrollbar {
            display: none;
          }
          .hide-scrollbar {
            scrollbar-width: none;
          }
          
          @media (max-width: 768px) {
            .px-md-4 {
              padding-left: 1rem !important;
              padding-right: 1rem !important;
            }
            .p-md-4 {
              padding: 1.5rem !important;
            }
          }
          
          @media (max-width: 480px) {
            .abouts-page-name {
              font-size: 18px !important;
            }
          }
            @media(max-width:768px) {
            .addmargintop{
            margin-top:2vh !important;
            }                  
            }
            
        `}
      </style>
    </Container>
  );
};

export default Aboutmaamaas;